export function CepMask(v:string) {
  v = v.replace(/\D/g, "");
  v = v.replace(/^(\d{5})(\d{3})$/g, "$1-$2");
  return v;
}